//Thease are top level segment props
//The prop names are the camelCase version of the TailWind Utiliy Classes.
export default ["rounded", "roundedT", "roundedR", "roundedB", "roundedL", "roundedTl", "roundedTr", "roundedBl", "roundedBr"];
